import BaseResource from './index'
import AgreementResource from './agreement'
import UnionLocalResource from './unionLocal'
import JobTitleResource from './jobTitle'

export default class OccCodeResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/occCode'
    static cacheMaxAge = 60

    static related() {
        return {
            agreement: AgreementResource,
            union_local: UnionLocalResource,
            job_title: JobTitleResource,
        }
    }
}
